// extracted by mini-css-extract-plugin
export default {"paging":"HistoryModalFooter_paging__4ey5j","placeHolderShimmer":"HistoryModalFooter_placeHolderShimmer__onOS-"};